import React from 'react';
import Breadcrumb from '../common/breadcrumb';
import Tabset from './tabset-editar-categoria';

const EditarCategoria = () => {
  return (
    <>
      <Breadcrumb title="Editar Categoria" parent="Categorias" />
      <div className="container-fluid">
        <div className="card">
          <div className="card-header">
            <h5>Editar Categoria</h5>
          </div>
          <div className="card-body">
            <Tabset />
          </div>
        </div>
      </div>
    </>
  );
}

export default EditarCategoria;
